<template>
  <div>
    <v-card>
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex sm6 xs12 d-flex>
            <v-toolbar flat color="white">
              <v-toolbar-title>Business List</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <v-btn color="primary" fab dark @click="openDialog()">
                <v-icon color="black">add</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
          <v-flex sm6 xs12 d-flex>
            <v-layout row wrap>
              <v-flex xs12 d-flex>
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Search by Business Name, Email, or Telephone"
                  single-line
                  hide-details
                  style="width: 100%"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :loading="loadingMessage"
        :items="filterbusinesslist"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-center">
            {{ props.item.company_provider_wesmart_name }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.company_provider_wesmart_type === 1
                ? "บุคคลธรรมดา"
                : "นิติบุคคล"
            }}
          </td>
          <td class="text-xs-center">
            {{ props.item.company_provider_wesmart_email || "-" }}
          </td>
          <td class="text-xs-center">
            {{ moment(props.item.create_at).format("YYYY/MM/DD") }}
          </td>
          <td class="text-xs-center">
            <span
              :class="statusClass(props.item.company_provider_wesmart_status)"
            >
              {{ statusText(props.item.company_provider_wesmart_status) }}
            </span>
          </td>
          <td class="text-xs-center">
            <v-btn icon @click="openDialog(props.item)">
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="businessDeatil(props.item.company_provider_wesmart_id)"
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="confirmDelete(props.item)"
              v-if="props.item.company_provider_wesmart_status != 4"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:no-data></template>
      </v-data-table>
      <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
        {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
        <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
      </v-snackbar>
    </v-card>
    <business-info-form-dialog
      :dialog="dialog"
      :businessData="selectedBusiness"
      @close="dialog = false"
      @save="saveBusiness"
    />
    <v-dialog v-model="deleteDialog" max-width="500px" persistent>
      <v-card style="border-radius: 10px">
        <v-toolbar
          dark
          style="background-color: #fddf00; color: black"
          class="elevation-0"
        >
          <v-toolbar-title>
            <h4>Confirm Delete</h4>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="deleteDialog = false" color="black" size="30"
            >close</v-icon
          >
        </v-toolbar>
        <v-card-text style="height: auto" class="px-4 pt-4">
          Are you sure you want to delete this business?
        </v-card-text>
        <v-card-actions style="padding-bottom: 30px" class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            style="
              width: 120px;
              background: #000000 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 6px #00000029;
              border-radius: 7px;
              font-weight: bold;
              letter-spacing: 0.1rem;
              color: white;
            "
            @click="deleteDialog = false"
            :disabled="isDeleting"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red"
            style="
              width: 120px;
              background: #000000 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 6px #00000029;
              border-radius: 7px;
              font-weight: bold;
              letter-spacing: 0.1rem;
              color: white;
            "
            @click="deleteBusinessItem"
            :loading="isDeleting"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import BusinessInfoFormDialog from "@/components/back-office/Business/business-info-form-dialog.vue";

export default {
  components: {
    BusinessInfoFormDialog,
  },
  props: ["searchLog"],
  data: () => ({
    search: "",
    loadingMessage: false,
    pagination: {
      rowsPerPage: 10,
    },
    headers: [
      { text: "No", sortable: false, align: "center" },
      {
        text: "Business Name",
        value: "user_provider_wesmart_first_name",
        sortable: false,
        align: "center",
      },
      {
        text: "Type",
        value: "company_provider_wesmart_type",
        sortable: false,
        align: "center",
      },
      {
        text: "Email",
        value: "user_provider_wesmart_email",
        sortable: false,
        align: "center",
      },
      { text: "Date", value: "create_at", sortable: false, align: "center" },
      {
        text: "Status",
        value: "company_provider_wesmart_status",
        sortable: false,
        align: "center",
      },
      { text: "Action", sortable: false, align: "center" },
    ],
    errSnackbar: false,
    snackBarMsg: null,
    data_loading: false,
    dialog: false,
    selectedBusiness: {},
    deleteDialog: false,
    businessToDelete: null,
    isDeleting: false,
  }),
  watch: {
    searchLog() {
      this.search = this.searchLog.status;
    },
  },
  computed: {
    ...mapState({
      businessListData: (state) => state.Business.businessListData,
    }),
    filterbusinesslist() {
      const order = [1, 2, 3, 5, 4];
      return this.businessListData
        .filter((item) => {
          const searchLower = this.search.toLowerCase();
          return (
            item.company_provider_wesmart_email
              .toLowerCase()
              .includes(searchLower) ||
            item.company_provider_wesmart_tel
              .toLowerCase()
              .includes(searchLower) ||
            item.company_provider_wesmart_name
              .toLowerCase()
              .includes(searchLower)
          );
        })
        .sort(
          (a, b) =>
            order.indexOf(a.company_provider_wesmart_status) -
            order.indexOf(b.company_provider_wesmart_status)
        );
    },
  },
  methods: {
    ...mapActions({
      getbankDetail: "banklist/fetchBankByid",
      createBusiness: "Business/createBusiness",
      updateBusiness: "Business/updateBusiness",
      deleteBusiness: "Business/deleteBusiness",
    }),
    async getData() {
      this.loadingMessage = true;
      const action = this.$route.name === "businesstable" ? "1" : "2";
      await this.$store.dispatch("Business/fetchBusinesslist", action);
      this.data_loading = true;
      this.loadingMessage = false;
    },
    businessDeatil(item) {
      if (item) {
        this.$router.push({
          name: "businessid",
          params: { business_id: item },
        });
      }
    },
    statusClass(status) {
      return {
        1: "badge_status--active",
        2: "badge_status--inactive",
        3: "badge_status--reject",
        4: "badge_status--delete",
        5: "badge_status--edit",
      }[status];
    },
    statusText(status) {
      return {
        1: "Pending",
        2: "Approve",
        3: "Reject",
        4: "Delete",
        5: "Edit document",
      }[status];
    },
    openDialog(business = {}) {
      this.selectedBusiness = business;
      this.dialog = true;
    },
    async saveBusiness(payload) {
      let business = payload.data;
      let response;
      if (business.company_id) {
        response = await this.updateBusiness(business);
        if (response && response.msg) {
          const index = this.businessListData.findIndex(
            (item) => item.company_provider_wesmart_id === business.company_id
          );
          if (index !== -1) {
            this.$set(this.businessListData, index, response.data);
          }
          payload.done();
          this.dialog = false;
          this.snackBarMsg = "Business updated successfully!";
        } else if (
          response &&
          response.data === "Phone number already exists"
        ) {
          payload.failed();
          this.snackBarMsg = "Phone number already exists.";
        } else {
          payload.failed();
          this.snackBarMsg = "Failed to update business.";
        }
      } else {
        response = await this.createBusiness(business);
        if (response && response.msg) {
          this.businessListData.push(response.data);
          payload.done();
          this.dialog = false;
          this.snackBarMsg = "Business created successfully!";
        } else if (
          response &&
          response.data === "Phone number already exists"
        ) {
          payload.failed();
          this.snackBarMsg = "Phone number already exists.";
        } else {
          payload.failed();
          this.snackBarMsg = "Failed to create business.";
        }
      }
      this.errSnackbar = true;
    },
    confirmDelete(business) {
      this.businessToDelete = business;
      this.deleteDialog = true;
    },
    async deleteBusinessItem() {
      this.isDeleting = true;
      const response = await this.deleteBusiness({
        company_id: this.businessToDelete.company_provider_wesmart_id,
      });

      if (response) {
        const index = this.businessListData.findIndex(
          (item) =>
            item.company_provider_wesmart_id ===
            this.businessToDelete.company_provider_wesmart_id
        );
        if (index !== -1) {
          this.businessListData[index].company_provider_wesmart_status = 4;
        }
        this.snackBarMsg = "Business deleted successfully!";
      } else {
        this.snackBarMsg = "Failed to delete business.";
      }
      this.errSnackbar = true;
      this.deleteDialog = false;
      this.isDeleting = false;
    },
    moment,
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.badge_status--active {
  background-color: #fbd200;
  color: #fff;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--inactive {
  background-color: #4caf50;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--reject {
  background-color: #fb3200;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--delete {
  background-color: #000000;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
}
.badge_status--edit {
  background-color: grey;
  color: #fff;
  padding: 5px 10px;
  border-radius: 12px;
  white-space: nowrap;
}
</style>
